import ExplorerLight from '@assets/images/icons/sidebar/light/explore-light.png'
import ExplorerDark from '@assets/images/icons/sidebar/dark/explore-dark.png'
import MessagesLight from '@assets/images/icons/sidebar/light/messages-light.png'
import MessagesDark from '@assets/images/icons/sidebar/dark/messages-dark.png'
import SubscriptionsLight from '@assets/images/icons/sidebar/light/subscriptions-light.png'
import SubscriptionsDark from '@assets/images/icons/sidebar/dark/subscriptions-dark.png'
import ComplianceLight from '@assets/images/icons/sidebar/light/compliance-light.png'
import ComplianceDark from '@assets/images/icons/sidebar/dark/compliance-dark.png'
import PipelineLight from '@assets/images/icons/sidebar/light/pipeline-light.png'
import PipelineDark from '@assets/images/icons/sidebar/dark/pipeline-dark.png'
import ProductsLight from '@assets/images/icons/sidebar/light/products-light.png'
import ProductsDark from '@assets/images/icons/sidebar/dark/products-dark.png'
import LeadPoolLight from '@assets/images/icons/sidebar/light/leadpool-light.png'
import LeadPoolDark from '@assets/images/icons/sidebar/dark/leadpool-dark.png'
import { ReactComponent as SupportIcon } from '@assets/images/icons/support.svg'
import Explorer from '../../pages/dashboard/explorer'
import Messages from '../../pages/dashboard/messages'
import Posting from '../../pages/dashboard/posting'
import Subscriptions from '../../pages/dashboard/subscriptions'
import Compliance from '../../pages/dashboard/compliance'
import SubscriptionPage from '@/pages/dashboard/subscriptions/subscription-page'
import Listings from '@/pages/dashboard/listings'
import Deals from '@/pages/dashboard/deals'
import LeadPoolPage from '@/pages/dashboard/lead-pool'
import StorefrontAdmin from '@/pages/storefront-admin'
import Backtesting from '@/pages/backtesting'
import RegisterClickPage from '@/pages/register-click/register-click-page'
import AdminConsole from '@/pages/admin'
import ReasoningTraces from '@/pages/dashboard/reasoning-traces'
import ReasoningTraceDetail from '@/pages/dashboard/reasoning-traces/detail'
import Datasources from '@/pages/dashboard/datasources'
import Datasource from '@/pages/datasource'
import Studio from '@/pages/dashboard/studio'

const Routes = [
  {
    path: '/',
    sidebarName: 'Explore',
    iconLight: ExplorerLight,
    iconDark: ExplorerDark,
    component: Explorer,
    userRole: 'both',
    isPublic: true,
  },
  /* {
    path: '/messages',
    sidebarName: 'Messages',
    iconLight: MessagesLight,
    iconDark: MessagesDark,
    component: Messages,
    userRole: 'both',
    isPublic: false,
  }, */
  {
    path: '/listings',
    sidebarName: 'Products',
    iconLight: ProductsLight,
    iconDark: ProductsDark,
    component: Listings,
    userRole: 'seller',
    isPublic: false,
  },
  {
    path: '/lead-pool',
    sidebarName: 'Lead Pool',
    iconLight: LeadPoolLight,
    iconDark: LeadPoolDark,
    component: LeadPoolPage,
    userRole: 'seller',
    isPublic: false,
  },
  {
    path: '/posting',
    sidebarName: 'Postings',
    iconLight: LeadPoolLight,
    iconDark: LeadPoolDark,
    component: Posting,
    userRole: 'buyer',
    isPublic: false,
    isHidden: true, // Hidden from sidebar navigation
  },
  {
    path: '/backtesting',
    sidebarName: 'Backtesting',
    iconLight: ComplianceLight,
    iconDark: ComplianceDark,
    userRole: 'buyer',
    component: Backtesting,
    isHidden: true, // Hidden from sidebar navigation
  },
  {
    path: '/studio',
    sidebarName: 'AI Studio',
    iconLight: MessagesLight,
    iconDark: MessagesDark,
    userRole: 'buyer',
    component: Studio,
    isPublic: false,
    isHidden: true, // Hidden from sidebar navigation
  },
  {
    path: '/reasoning-traces',
    sidebarName: 'Reasoning Traces',
    iconLight: ComplianceLight,
    iconDark: ComplianceDark,
    userRole: 'buyer',
    component: ReasoningTraces,
    isPublic: false,
  },
  {
    path: '/reasoning-traces/:sessionId',
    component: ReasoningTraceDetail,
    userRole: 'buyer',
    isHidden: true,
  },
  {
    path: '/datasources',
    sidebarName: 'Data Sources',
    iconLight: ComplianceLight,
    iconDark: ComplianceDark,
    userRole: 'buyer',
    component: Datasources,
    isPublic: false,
    isHidden: true, // Hidden from sidebar navigation
  },
  {
    path: '/datasource/:datasourceId',
    component: Datasource,
    userRole: 'buyer',
    isHidden: true,
  },
  {
    path: '/deals',
    sidebarName: 'Pipeline',
    iconLight: PipelineLight,
    iconDark: PipelineDark,
    component: Deals,
    userRole: 'both',
    isPublic: false,
    isHidden: true, // Hidden from sidebar navigation
  },
  {
    path: '/subscriptions',
    sidebarName: 'Subscriptions',
    iconLight: SubscriptionsLight,
    iconDark: SubscriptionsDark,
    component: Subscriptions,
    userRole: 'both',
    isPublic: false,
    isHidden: true, // Hidden from sidebar navigation
  },
  {
    path: '/compliance',
    sidebarName: 'Legal & Compliance',
    iconLight: ComplianceLight,
    iconDark: ComplianceDark,
    component: Compliance,
    userRole: 'both',
    isPublic: false,
  },
  {
    path: '/subscriptions/:id',
    sidebarName: 'Subscriptions',
    component: SubscriptionPage,
    userRole: 'buyer',
    isHidden: true,
  },
  {
    path: '/storefront-admin',
    sidebarName: 'Storefront Admin',
    component: StorefrontAdmin,
    userRole: 'seller',
    isHidden: true,
  },
  {
    path: '/data-valuation',
    sidebarName: 'Data Valuation',
    iconLight: ProductsLight,
    iconDark: ProductsDark,
    component: RegisterClickPage,
    userRole: 'seller',
    isPublic: false,
    target: '_blank',
  },
  {
    path: '/data-backed-lending',
    sidebarName: 'Data-backed Lending',
    iconLight: ProductsLight,
    iconDark: ProductsDark,
    component: RegisterClickPage,
    userRole: 'seller',
    isPublic: false,
    target: '_blank',
  },
  {
    path: '/admin-console',
    sidebarName: 'Admin Console',
    component: AdminConsole,
    userRole: 'both',
    isHidden: false,
    iconLight: ComplianceLight,
    iconDark: ComplianceDark,
  },
  {
    path: '/contact-support',
    sidebarName: 'Support',
    iconLight: SupportIcon,
    iconDark: SupportIcon,
    component: null, // No direct component for this route, it's a placeholder
    userRole: 'both',
    isPublic: true,
    isHidden: false,
  },
]

export default Routes
